var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M1.5,25a1.5,1.5,0,0,1-1-2.59l9.91-9.33L.41,2.53A1.5,1.5,0,1,1,2.59.47l11,11.65A1.51,1.51,0,0,1,14,13.19a1.49,1.49,0,0,1-.47,1.05l-11,10.35A1.47,1.47,0,0,1,1.5,25Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }